module.exports = "https://staticsandbox.coteibem.com.br/assets/selo-360-small.9eb37407453d698a237fac6e7828beb9.svg";